import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
import { CBG } from '../../../../actions/utilAction';
Exporting(Highcharts);
ExportingData(Highcharts);


class AnalyticsDataComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount = () => {
        this.highchartsHandler();
    }

    highchartsHandler = () => {
        let finalData = [];
        let behaviorsReductionId = [];
        let xAxisDate = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? this.props.agencyName.toUpperCase() === CBG ? 'Frequency' : 'Data' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? this.props.agencyName.toUpperCase() === CBG ? 'Sessions' : 'Date' : this.props.yAxisName;
        let disableYaxislabel = this.props.disableYaxislabel;
        let disableXaxislabel = this.props.disableXaxislabel;
        //let selectedProgram = this.props.selectedProgram;
        if (this.props.dataAnalytics.dataAnalyticsData.data.patientBehaviorsReductions.length > 0) {
            this.props.dataAnalytics.dataAnalyticsData.data.patientBehaviorsReductions.map((obj, index) => {
                let dataObj = {}
                let behaviorData = [];
                let behaviordataForDate = this.props.dataAnalytics.dataAnalyticsData.data.patientBehaviorsReductions;
                for (let i = 0; i < behaviordataForDate.length; i++) {
                    if(xAxisDate.indexOf(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDate.push(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY'));
                    }
                }

                if(behaviorsReductionId.indexOf(obj.behaviorsReductionId) === -1)
                {
                    let goaldata = this.props.dataAnalytics.dataAnalyticsData.data.patientBehaviorsReductions.filter((op) => op.behaviorsReductionId === obj.behaviorsReductionId);
                    behaviorData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].behaviorName;
                        dataObj['behaviorsReductionId'] = goaldata[i].behaviorsReductionId;
                        behaviorsReductionId.push(goaldata[i].behaviorsReductionId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            behaviorData[index] = goaldata[i].behaviorData;
                            // behaviorData.push(goaldata[i].behaviorData);
                        }
                    }

                    for(let j = 0; j < behaviorData.length; j++)
                    {
                        //if(!behaviorData[j])
                        if(behaviorData[j] === undefined)
                        {
                            behaviorData[j] = null;
                        }
                    }
                    dataObj['data'] = behaviorData;
                    finalData.push(dataObj);
                }
            })
        }
        finalData.reverse();
        Highcharts.setOptions({
            colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
        });

        Highcharts.chart('analyticsDataDiv', {

            title: {
                text: 'Behavior Name'
            },

            yAxis: {
                title: {
                text: `<b>${xAxisLabel}</b>`
                },
                labels: {
                    enabled: disableYaxislabel
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },

            xAxis: {
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                tickLength: 0,
                categories: xAxisDate,
                labels: {
                    enabled: disableXaxislabel
                }
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                series: {
                    cursor: 'pointer',
                    connectNulls:true,
                    fillOpacity: 0.6,
                    label: {
                        connectorAllowed: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                }
            },

            series: finalData,

            // series: [{
            //     name: 'Installation',
            //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
            // }, {
            //     name: 'Manufacturing',
            //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
            // }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },

            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },

            lang: {
                contextButtonTitle: 'Click to open'
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }

    render() {
        return (
            <div className='col-sm-12'>
                <div id='analyticsDataDiv' style={{ height: '500px' }} />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        dataAnalytics: state.dataAnalytics,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    };
}

export default connect(mapStateToProps, null)(AnalyticsDataComponent)


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalyticsBehaviors/analyticsDataComponent.js